// Featured homepage case study — the Prichard Mall idea.
// Seeded via migration; see supabase migration history.
export const FEATURED_IDEA_ID = "a11ce100-0000-4000-8000-0000000c1ded";
export const FEATURED_IDEA_TITLE = "Revitalize Prichard's Mall";
export const FEATURED_LOCATION = "Prichard, AL";

// Featured plan — the civic thesis the platform is executing against.
// Prichard Mall (and future ideas) sit under this as initiatives.
export const FEATURED_PLAN = {
  slug: "mobile-financial-empowerment-action-plan-analysis",
  shortTitle: "Financial Empowerment Action Plan",
  fullTitle: "City of Mobile Financial Empowerment Action Plan",
  location: "City of Mobile, AL",
  href: "/insights/mobile-financial-empowerment-action-plan-analysis",
  stats: [
    { value: "52%", label: "Black population, business ownership gap" },
    { value: "8%", label: "Unbanked · 17% underbanked" },
    { value: "3", label: "Priority zip codes: 36603 · 36605 · 36617" },
  ],
} as const;